module.exports = __webpack_public_path__ + "static/img/right_Down.39c3fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_Down.png?1
// module id = Zu0B
// module chunks = 1